export const GET_ADMIN_DASHBOARD_OVERVIEW_REQUEST =
  "GET_ADMIN_DASHBOARD_OVERVIEW_REQUEST";
export const GET_ADMIN_DASHBOARD_OVERVIEW_RESPONSE =
  "GET_ADMIN_DASHBOARD_OVERVIEW_RESPONSE";
export const GET_ADMIN_DASHBOARD_QUICK_ACTIONS_REQUEST =
  "GET_ADMIN_DASHBOARD_QUICK_ACTIONS_REQUEST";
export const GET_ADMIN_DASHBOARD_QUICK_ACTIONS_RESPONSE =
  "GET_ADMIN_DASHBOARD_QUICK_ACTIONS_RESPONSE";
export const GET_ADMIN_DASHBOARD_TOP_COMPANIES_REQUEST =
  "GET_ADMIN_DASHBOARD_TOP_COMPANIES_REQUEST";
export const GET_ADMIN_DASHBOARD_TOP_COMPANIES_RESPONSE =
  "GET_ADMIN_DASHBOARD_TOP_COMPANIES_RESPONSE";
export const GET_ADMIN_DASHBOARD_OVERVIEW_FAILURE =
  "GET_ADMIN_DASHBOARD_OVERVIEW_FAILURE";
export const GET_ADMIN_DASHBOARD_QUICK_ACTIONS_FAILURE =
  "GET_ADMIN_DASHBOARD_QUICK_ACTIONS_FAILURE";
export const GET_ADMIN_DASHBOARD_TOP_COMPANIES_FAILURE =
  "GET_ADMIN_DASHBOARD_TOP_COMPANIES_FAILURE";
export const GET_ADMIN_DASHBOARD_TOP_EVENTS_REQUEST =
  "GET_ADMIN_DASHBOARD_TOP_EVENTS_REQUEST";
export const GET_ADMIN_DASHBOARD_TOP_EVENTS_RESPONSE =
  "GET_ADMIN_DASHBOARD_TOP_EVENTS_RESPONSE";
export const GET_ADMIN_DASHBOARD_TOP_EVENTS_FAILURE =
  "GET_ADMIN_DASHBOARD_TOP_EVENTS_FAILURE";
export const GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_REQUEST =
  "GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_REQUEST";
export const GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_RESPONSE =
  "GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_RESPONSE";
export const GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_FAILURE =
  "GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_FAILURE";
export const GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_REQUEST =
  "GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_REQUEST";
export const GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_RESPONSE =
  "GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_RESPONSE";
export const GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_FAILURE =
  "GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_FAILURE";
export const GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_REQUEST =
  "GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_REQUEST";
export const GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_RESPONSE =
  "GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_RESPONSE";
export const GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_FAILURE =
  "GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_FAILURE";
